import styled from 'styled-components/macro';
import { Container, Row } from '@yme/atoms/grid';
import { ADAPTIVE } from '@yme/tokens/screen';
export const GridRowStyled = styled(Row) `
  margin-left: -8px;
  margin-right: -8px;

  ${ADAPTIVE.minWidth.tablet} {
    margin-left: -12px;
    margin-right: -12px;
  }
`;
export const GridContainerStyled = styled(Container) `
  margin-left: 0;
  margin-right: 0;
`;
export const FilterWrapperStyled = styled.div `
  width: 100%;
`;
export const SortOrderStyled = styled.div `
  width: 100%;
`;
